import axios from 'axios';
import { getModuleOncePerPage } from '../_apis_/DynamicModulePath';

export const API = axios.create({ baseURL: process.env.REACT_APP_API_URL })

API.interceptors.request.use(req => {
    // Handle Authorization Token
    const token = window.localStorage.getItem('accessToken');
    if (token) {
        req.headers.Authorization = `Token ${token}`;
    }

    // Checking if this API request should carry the module/page header
    const activeModule = getModuleOncePerPage(req.url);

    if (activeModule) {
        // If a valid module matches and it's qualified to send, attach it
        req.headers['X-Module-Name'] = activeModule;

        // If you specifically want to send the raw pathname or URL instead of the mapped name:
        // req.headers['X-Current-Page-URL'] = window.location.href;
    } else {
        // Ensure the header isn't leaked or left over from previous requests
        delete req.headers['X-Module-Name'];
    }

    return req;
}, (error) => {
    return Promise.reject(error);
});

//  ------

// request interceptor (just attach token, no expiry check)
// API.interceptors.request.use(
//     (config) => {
//         const token = localStorage.getItem("accessToken");
//         if (token) {
//             config.headers.Authorization = `Bearer ${token}`;
//         }
//         return config;
//     },
//     (error) => Promise.reject(error)
// );

// // response interceptor (handle 401 and refresh)
// API.interceptors.response.use(
//     (response) => response,
//     async (error) => {
//         const originalRequest = error.config;

//         if (
//             error.response?.status === 401 &&
//             !originalRequest._retry &&
//             !originalRequest.url.includes("/auth/refresh")
//         ) {
//             originalRequest._retry = true;

//             try {
//                 const res = await axios.post("https://your-api.com/auth/refresh", {
//                     refreshToken: localStorage.getItem("refreshToken"),
//                 });

//                 const newAccessToken = res.data.accessToken;
//                 localStorage.setItem("accessToken", newAccessToken);

//                 originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;
//                 return axiosInstance(originalRequest);
//             } catch (err) {
//                 localStorage.removeItem("accessToken");
//                 localStorage.removeItem("refreshToken");
//                 window.location.href = "/login";
//                 return Promise.reject(err);
//             }
//         }

//         return Promise.reject(error);
//     }
// );
